import { EnvironmentInjector, inject, Injectable, Injector, runInInjectionContext } from "@angular/core";
import { Actions, createEffect, FunctionalEffect, ofType } from "@ngrx/effects";
import { map } from "rxjs";
import { postActions } from "./post.actions";
import { BlueprintEffectClass } from "../../../instance-service/effect-class-blueprint";
import { PostBlueprint } from "../post";

@Injectable()
export class PostEffects extends BlueprintEffectClass<PostBlueprint> {
  override actions$ = inject(Actions);
  override actions: ReturnType<typeof postActions>
  override instance: PostBlueprint


  moveTest = createEffect(() => {
    return this.actions$.pipe(
      ofType(this.actions.move),
      map((action) => {
        // console.log("POST EFFECT MOVE!!!", JSON.stringify(action))
      }),
    )}, { functional: true, dispatch: false },
  )
}
